__turbopack_context__.v({
  "trashMovedPopoverWrapper": "TrashMovedPopover-module__FmGxhG__trashMovedPopoverWrapper",
});
